import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastWrapper = () => {
  return (
    <>
      <ToastContainer style={{ width: 'auto' }}/>
    </>
  )
}